import {
  SetStateAction,
  useRef,
  useState,
  useEffect,
  useCallback,
} from 'react';

import { Nullable } from '~globals/types/commons';

type Callback<S> = (state: S) => void | (() => void | undefined);

type DispatchWithCallback<A, S> = (value: A, callback: Callback<S>) => void;

export const useStateWithCallbackLazy = <S>(
  inititalValue: S,
): [S, DispatchWithCallback<SetStateAction<S>, S>] => {
  const callbackRef = useRef<Nullable<Callback<S>>>(null);

  const [value, setValue] = useState(inititalValue);

  useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current(value);

      callbackRef.current = null;
    }
  }, [value]);

  const setValueWithCallback = useCallback<
    DispatchWithCallback<SetStateAction<S>, S>
  >((newValue, callback) => {
    callbackRef.current = callback;
    return setValue(newValue);
  }, []);

  return [value, setValueWithCallback];
};
